import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Steps, { Step } from "rc-steps";
import "rc-steps/assets/index.css";
import "rc-steps/assets/iconfont.css";
import {
  Button,
  Row,
  Col,
  Container,
  ProgressBar,
  Form,
  ButtonGroup,
  Tooltip,
  OverlayTrigger,
  Modal,
  Spinner,
  Alert,
  Card,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import toastr from "toastr";
import moment from "moment";

import {
  getCapacitaciones,
  getCapacitacion,
  getBloque,
  enviarCorreo,
  resetBloque,
  getBloqueAnteriorAnterior,
  editBloqueDocGD,
  saveBloqueDocGD,
} from "../../../redux/on&offBoarning/capacitacion/actions";

import config from "../../../config";

import CustomNavbar from "../../../components/CustomNavbar";
import SidebarConfig from "../../../components/SidebarDashboard";

import CustomTable from "../../../components/CustomTable";

import perfilImage from "../../../images/perfil3.jpg";
import {
  //editDoc,
  getAreas,
  getCarpetas,
  //getDocs,
  getSubNiveles,
  //saveDoc,
} from "../../../redux/gestorDocumental/actions";
import LinkDescargaGD from "../../../components/gestorDocumental/LinkDescargaGD";
import { getEmployee } from "../../../redux/employees/actions";
import LinkDescargaListGD from "../../../components/gestorDocumental/LinkDescargaListGD";
import { getBase64 } from "../../../components/gestorDocumental/GestorDocumental";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

const Capacitacion = (props) => {
  const [show, setShow] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [showModalCompañero, setShowModalCompañero] = useState(false);
  const [AnteriorB, setAnterior] = useState(null);
  const [current, setCurrent] = useState(0);
  const [actualBloque, setActualBloque] = useState(0);
  const [SiguienteB, setSiguiente] = useState(null);
  const [now, setNow] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [index, setIndex] = useState(0);
  //const [docs, setDocs] = useState([])
  // const [fileName, setFileName] = useState("Imagen, pdf, documento, etc.");
  // const [habilitarBienvenida, setHabilitarBienvenida] = useState(false);
  const [Mensaje, setMensaje] = useState(false);
  //const [fileTemp, setFileTemp] = useState("");
  const [validated, setValidated] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const { capacitacion, bloques, loading, loadingBloque, bloque, tareas } =
    useSelector((store) => store.capacitacion);

  const userInfo = useSelector((store) => store.employees.employee);
  const userId = useSelector((store) => store.auth.id);
  const userN = useSelector((store) => store.auth.username);

  const {
    areas,
    carpetas,
    subNiveles,
    areasError,
    carpetasError,
    error,
    formErrors,
    // docs,
    //loaderSubNiveles,
    // loadingDocs,
    // loadingAreas,
    // loadingCarpetas,
    // saveDocsLoading,
    subNivelesError,
  } = useSelector((store) => store.gestorDocumental);

  const { carpeta, tipoDocumentoGD, tipoDocumento, descripcion } =
    config.gestorDocumental.onboarding;
  const { area, email } = config.gestorDocumental;

  const columns = [
    {
      id: "CheckBoxActividad",
      Header: "",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Form>
            <Form.Check
              type="checkbox"
              id="custom-switch"
              value={value.row.original.id}
              onChange={handleCheckbox}
              checked={value.row.original.estado}
              disabled={true}
            />
          </Form>
        </div>
      ),
    },
    {
      id: "Actividad",
      Header: "Actividad",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <p>{value.row.original.nombre}</p>
        </div>
      ),
    },
    {
      id: "FechaLimite",
      Header: "Fecha",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <p>{moment(value.row.original.fecha_fin).format("DD/MM/YYYY")}</p>
        </div>
      ),
    },
    {
      id: "Responsable",
      Header: "Responsable",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <p>
            {capacitacion &&
              capacitacion.datos_responsable &&
              `${capacitacion.datos_responsable[0].first_name}${" "}
            ${capacitacion.datos_responsable[0].last_name}`}
          </p>
        </div>
      ),
    },
    {
      id: "EmailResponsable",
      Header: "Email Responsable",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <p>{capacitacion.datos_responsable[0].email}</p>
        </div>
      ),
    },
    {
      id: "Estado",
      Header: "Estado",
      Filter: "",
      Cell: (value) => (
        <div className="d-flex justify-content-between">
          <p>{value.row.original.estado ? "Completado" : "Pendiente"}</p>
        </div>
      ),
    },
    {
      id: "Calificación",
      Header: "Calificación",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <p>
            {value.row.original.evaluable
              ? value.row.original.calificacion
              : null}
          </p>
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {value.row.original.archivo_bajar && (
            <OverlayTrigger
              placement="auto"
              overlay={
                <Tooltip {...props}>
                  Descargar documentación proporcionada
                </Tooltip>
              }
            >
              <Button
                size="sm"
                variant="link"
                type="button"
                className="text-primary btn rounded-pill"
                onClick={() => {
                  const win = window.open(
                    `${process.env.REACT_APP_URL}/media/${value.row.original.archivo_bajar}`,
                    "_blank"
                  );
                  win.focus();
                }}
              >
                <i className="material-icons">file_download</i>
              </Button>
            </OverlayTrigger>
          )}
          {value.row.original.subir_archivo === true && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Subir archivo</Tooltip>}
            >
              <Button
                size="sm"
                variant="link"
                type="button"
                className="text-primary btn rounded-pill"
                onClick={() => onViewImg(value.row.original, value.row.index)}
                disabled={current !== actualBloque || value.row.original.estado}
              >
                <i className="material-icons">upload</i>
              </Button>
            </OverlayTrigger>
          )}
          {value.row.original.archivo_gestor && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Ver documento subido</Tooltip>}
            >
              <LinkDescargaListGD
                id={value.row.original.id}
                filters={{
                  email: email,
                  id: value.row.original.archivo_gestor[0].id_documento,
                  llave: value.row.original.archivo_gestor[0].llave,
                }}
                origen={value.row.original.archivo_gestor[0].origen}
                icono={<i className="material-icons">file</i>}
                cType={value.row.original.archivo_gestor[0].contentTypeGD}
              />
            </OverlayTrigger>
          )}
          {value.row.original.datos_compa_guia &&
            value.row.original.datos_compa_guia.length > 0 && (
              <OverlayTrigger
                placement="auto"
                overlay={
                  <Tooltip {...props}>Responsable de la actividad</Tooltip>
                }
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  className="text-info btn rounded-pill"
                  onClick={() => onViewCompañero(value.row.original)}
                >
                  <i className="material-icons">follow_the_signs</i>
                </Button>
              </OverlayTrigger>
            )}
          {value.row.original.enlace_evaluacion &&
            value.row.original.enlace_evaluacion !== "null" && (
              <OverlayTrigger
                placement="auto"
                overlay={
                  <Tooltip {...props}>Cuestionario de Evaluación</Tooltip>
                }
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  className="text-info btn rounded-pill"
                  onClick={() => {
                    const win = window.open(
                      value.row.original.enlace_evaluacion
                    );
                    win.focus();
                  }}
                  disabled={
                    current !== actualBloque || value.row.original.estado
                  }
                >
                  <i className="material-icons">quiz</i>
                </Button>
              </OverlayTrigger>
            )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (userN !== "") {
      dispatch(resetBloque());
      dispatch(
        getCapacitacion(
          { filter: userN, tipo_busqueda: "empleado" },
          parseInt(props.match.params.id)
        )
      );
      // dispatch(
      //   getDocs({
      //     id_empleado: parseInt(userId),
      //     tipo_documento: tipoDocumento,
      //   }, setDocs)
      // );
      dispatch(getAreas());
      dispatch(getCarpetas());
    }
    if (userId) {
      dispatch(
        getEmployee(userId, parseInt(props.match.params.type))
      );
    }
  }, [props.match.params.id, userN, userId]);

  useEffect(() => {
    if (capacitacion && bloques && bloques.length > 0) {
      var variableTemp = 0;
      var variableCont = 0;
      var varUna = 1;
      // if (parseInt(props.match.params.tipoWorkflow) === 1) {
      //   setHabilitarBienvenida(true);
      // } else {
      //   setHabilitarBienvenida(false);
      // }
      bloques
        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
        .map((item, index) => {
          if (!item.estado && varUna === 1) {
            varUna = varUna - 1;
            setCurrent(parseInt(index));
            setActualBloque(parseInt(index));
            if (index === bloques.length - 1) {
              setAnterior(parseInt(index) - 1);
              setSiguiente(null);
            } else if (index > 0) {
              setAnterior(parseInt(index) - 1);
              setSiguiente(parseInt(index) + 1);
            } else if (index === 0) {
              setAnterior(null);
              setSiguiente(parseInt(index) + 1);
            }
            dispatch(getBloque({}, item.id));
          }
          if (item.workflow_tareas) {
            item.workflow_tareas.map((tarea) => {
              if (tarea.estado) {
                variableTemp = parseInt(variableTemp) + 1;
              }
              variableCont = parseInt(variableCont) + 1;
            });
          }
        });
      if (varUna === 1) {
        setMensaje(true);
        setCurrent(parseInt(bloques.length) - 1);
        setActualBloque(parseInt(bloques.length) - 1);
        setAnterior(parseInt(bloques.length) - 2);
        setSiguiente(null);
        dispatch(getBloque({}, bloques[parseInt(bloques.length) - 1].id));
      } else {
        setMensaje(false);
      }
      setNow((variableTemp / variableCont).toFixed(2) * 100);
    } else {
      setNow((0).toFixed(0) * 100);
    }
  }, [capacitacion, bloques, props.match.params]);

  useEffect(() => {
    if (current && bloques && bloques[current].id && current === AnteriorB) {
      dispatch(getBloqueAnteriorAnterior({ bloque: bloques[current].id }));
    } else if (
      current &&
      bloques &&
      bloques[current].id &&
      current !== actualBloque &&
      current !== SiguienteB
    ) {
      dispatch(getBloqueAnteriorAnterior({ bloque: bloques[current].id }));
    }
  }, [current]);

  useEffect(() => {
    if (areas && areas.length > 0 && carpetas && carpetas.length > 0) {
      const oCarpeta = carpetas.find(
        (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
      );
      dispatch(
        getSubNiveles({
          areaid: areas[0].id,
          ceid: oCarpeta.id,
        })
      );
    }
  }, [areas, carpetas]);

  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    if (checked) {
      dispatch(
        enviarCorreo({
          workflow_id: parseInt(props.match.params.id),
          bloque_id: parseInt(bloque.id),
          tarea_id: parseInt(checkValue),
        })
      );
      dispatch(getCapacitaciones({ filter: userN, tipo_busqueda: "empleado" }));
    } else {
    }
  };

  const onViewImg = (item, index) => {
    setEditItem(item);
    setIndex(index);
    setShowModalView(true);
  };

  const onViewCompañero = (item) => {
    setEditItem(item);
    setShowModalCompañero(true);
  };

  const onSubmitDocImg = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    if (
      e.target.documentos.files.length > 0 &&
      e.target.fechaDoc.value === ""
    ) {
      setValidated(true);
      return;
    }
    if (e.target.documentos.files.length === 0) {
      return;
    }

    const empresaT = userInfo.empresa[0];
    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    const filebase64 = await getBase64(e.target.documentos.files[0]);
    const fileName = e.target.documentos.files[0].name;
    const fName = String(fileName)
      .substring(0, String(fileName).lastIndexOf("."))
      .replace(/\W/g, "");
    const fExt = `.${String(fileName).substr(
      fileName.lastIndexOf(".") + 1 - fileName.length
    )}`;
    const aFileBase = String(filebase64).split(",");

    var cap = new FormData();
    cap.append("id_empleado", parseInt(userId));
    cap.append("tipo_documento", tipoDocumento);
    cap.append("archivo", aFileBase[1]);
    cap.append("contentTypeGD", `${aFileBase[0]},`);
    cap.append("origen", fName + fExt);
    cap.append("extension", fExt);
    cap.append("tipo_documento_GD", tipoDocumentoGD);
    cap.append("descripcion", e.target.documentDesc.value);
    cap.append("fecha", moment().format("YYYY-MM-DD"));
    cap.append("id_area", oArea.id);
    cap.append("id_carpeta_encabezado", oCarpeta.id);
    cap.append("empresa", empresaT);
    cap.append("zona", userInfo.Division_Personal_List[0].descripcion);
    cap.append("id_registro", parseInt(editItem.id));

    const exist = e.target.documentos.files.length > 0;
    if (editItem && editItem.archivos_gestor) {
      dispatch(
        editBloqueDocGD(cap, editItem, index, editItem.archivos_gestor, exist, bloques[current].id)
      );
    } else {
      dispatch(saveBloqueDocGD(cap, editItem, parseInt(index), exist, bloques[current].id));
    }
    e.target.reset();
    setEditItem({});
    setShowModalView(false);
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <Col md="12" className="mx-auto mt-4">
            <Row className="d-flex justify-content-between align-items-center flex-nowrap">
              <Col xs="auto" className="px-3">
                <h4 className="font-weight-bold text-uppercase m-0">
                  Capacitación
                </h4>
              </Col>
              {capacitacion && capacitacion.tipo_workflow === 1 && (
                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Tooltip {...props}>Visualizar carta de bienvenida</Tooltip>
                  }
                >
                  <Button
                    variant="primary"
                    size="md"
                    className="btn shadow-sm rounded mr-3"
                    onClick={() =>
                      history.push(
                        `/capacitacion/bienvenida/${
                          props.match.params.name
                        }/${parseInt(props.match.params.id)}/${parseInt(
                          props.match.params.tipoWorkflow
                        )}/${props.match.params.type}`
                      )
                    }
                  >
                    <p className="m-0 d-flex">
                      Carta
                      <i className="material-icons ml-2">history_edu</i>
                    </p>
                  </Button>
                </OverlayTrigger>
              )}
            </Row>
          </Col>
          <div className="px-3 shadow-sm">
            <hr />
          </div>
          {loading ? (
            <div className="d-flex justify-content-center"></div>
          ) : capacitacion && capacitacion.workflow_bloques === null ? (
            <div></div>
          ) : capacitacion && bloques && bloques.length > 0 ? (
            <Col md="11" className="mx-auto mt-4">
              <Col className="mb-3 mr-auto bg-white p-2">
                <h5 className="font-weight-bold text-uppercase m-0">
                  {props.match.params.name}
                </h5>
              </Col>
              <div className="shadow-sm">
                <hr />
              </div>
              {Mensaje && (
                <Row className="mb-1 justify-content-start align-items-center flex-nowrap">
                  <Col className="bg-white px-0">
                    <Alert
                      variant="info"
                      className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
                    >
                      <i className="material-icons mx-3">info</i>
                      WorkFlow completado
                    </Alert>
                  </Col>
                </Row>
              )}
              <Row className="mb-1 justify-content-start align-items-center flex-nowrap">
                <Col className="bg-white px-3" md="5">
                  <ProgressBar className="shadow-sm rounded-pill">
                    <ProgressBar variant="primary" now={now} visuallyHidden />
                    <ProgressBar
                      variant="secondary"
                      now={100 - now}
                      visuallyHidden
                    />
                  </ProgressBar>
                </Col>
                <Col md="3">
                  <Col
                    md="4"
                    className="rounded-pill shadow-sm"
                    style={{ border: "1px solid #ced4da" }}
                  >
                    <p style={{ textAlign: "center" }}>
                      <b>
                        {100 - now === 100
                          ? `${parseFloat(0).toFixed(0)}%`
                          : `${parseFloat(now).toFixed(0)}%`}
                      </b>
                    </p>
                  </Col>
                </Col>
              </Row>
            </Col>
          ) : null}
          <Col className="mx-auto p-3" md="11">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Spinner
                  animation="border"
                  role="status"
                  className="d-flex justify-content-center"
                />
              </div>
            ) : capacitacion &&
              capacitacion.workflow_bloques === null &&
              !loading ? (
              <Alert
                variant="info"
                className="my-4 d-flex flex-wrap justify-content-start align-items-center"
              >
                <i className="material-icons mx-3">info</i>
                No tiene ninguna actividad disponible, para mas información
                contactar al administrador.
              </Alert>
            ) : capacitacion && bloques && bloques.length > 0 && !loading ? (
              <Steps
                style={{
                  border: "1px solid rgb(235, 237, 240)",
                  overflowX: "auto",
                }}
                className="shadow-sm px-3 pb-2 pt-3 rounded d-flex"
                direction="horizontal"
                type="navigation"
                current={current}
                // status="error"
                // status="process"
                // status="finish"
                // status="wait"
              >
                {bloques
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((item, index) => (
                    <Step
                      title={item.nombre}
                      className="m-4"
                      status={
                        (index === SiguienteB || index === actualBloque) &&
                        bloques[index].estado === false
                          ? "process"
                          : AnteriorB !== null && index === AnteriorB
                          ? "finish"
                          : SiguienteB !== null && index > SiguienteB
                          ? "wait"
                          : AnteriorB !== null && index < AnteriorB
                          ? "finish"
                          : index === actualBloque &&
                            bloques[index].estado === true
                          ? "finish"
                          : null
                      }
                    />
                  ))}
              </Steps>
            ) : null}
          </Col>
          {loadingBloque ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : tareas && tareas.length < 0 ? (
            <Alert
              variant="info"
              className="my-4 ml-3 mr-3 d-flex flex-wrap justify-content-start align-items-center"
            >
              <i className="material-icons mx-3">info</i>
              No tiene tareas asignadas, para mas información contactar al
              administrador.
            </Alert>
          ) : capacitacion &&
            capacitacion.workflow_bloques &&
            capacitacion.workflow_bloques.length > 0 &&
            bloque &&
            tareas ? (
            <>
              <Col md="11" className="mx-auto mb-3">
                <Col
                  className="mb-1 mx-auto p-3 bg-white rounded"
                  style={{ borderBottom: "1px solid rgb(235, 237, 240)" }}
                >
                  {loadingBloque ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : bloque ? (
                    <h6>
                      <b>{bloque.nombre}</b>
                    </h6>
                  ) : (
                    ""
                  )}
                </Col>
              </Col>
              <Col md="11" className="mx-auto mb-3">
                <Col
                  className="shadow-sm mb-1 mx-auto p-3 bg-white rounded"
                  style={{ border: "1px solid rgb(235, 237, 240)" }}
                >
                  <CustomTable
                    columns={columns}
                    data={tareas.sort((a, b) => {
                      return a.posicion - b.posicion;
                    })}
                  />
                </Col>
              </Col>
              <Col md="11" className="mx-auto">
                <Col className="mx-auto p-3 bg-white rounded d-flex flex-wrap justify-content-end align-items-end">
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip {...props}>Bloque anterior</Tooltip>}
                    >
                      <Button
                        variant="primary"
                        className="m-3 p-1 px-2 shadow-sm rounded-pill d-flex"
                        onClick={() => {
                          if (current > 0) {
                            const cTemp = parseInt(current) - 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          }
                        }}
                        disabled={current === 0}
                      >
                        <i className="material-icons">navigate_before</i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip {...props}>Bloque siguiente</Tooltip>}
                    >
                      <Button
                        variant="primary"
                        className="m-3 p-1 px-2 shadow-sm rounded-pill d-flex"
                        onClick={() => {
                          if (SiguienteB && current < SiguienteB) {
                            const cTemp = parseInt(current) + 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          } else if (current < actualBloque) {
                            const cTemp = parseInt(current) + 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          }
                        }}
                        disabled={
                          SiguienteB === current ||
                          (actualBloque === current && SiguienteB === null) ||
                          SiguienteB === -1
                        }
                      >
                        <i className="material-icons">navigate_next</i>
                      </Button>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Col>
            </>
          ) : null}
          {bloque && bloque.workflow_tareas === null && (
            <>
              <Col md="11" className="mx-auto mb-3">
                <Col
                  className="mb-1 mx-auto p-3 bg-white rounded"
                  style={{ borderBottom: "1px solid rgb(235, 237, 240)" }}
                >
                  {loadingBloque ? (
                    <div className="d-flex justify-content-center">
                      <Spinner
                        animation="border"
                        role="status"
                        className="d-flex justify-content-center"
                      />
                    </div>
                  ) : bloque ? (
                    <h6>
                      <b>{bloque.nombre}</b>
                    </h6>
                  ) : (
                    ""
                  )}
                </Col>
              </Col>
              <Col md="11" className="mx-auto">
                <Alert
                  variant="info"
                  className="my-4 d-flex flex-wrap justify-content-start align-items-center"
                >
                  <i className="material-icons mx-3">info</i>
                  No tiene ninguna actividad disponible, para mas información
                  contactar al administrador.
                </Alert>
              </Col>
              <Col md="11" className="mx-auto">
                <Col className="mx-auto p-3 bg-white rounded d-flex flex-wrap justify-content-end align-items-end">
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip {...props}>Bloque anterior</Tooltip>}
                    >
                      <Button
                        variant="primary"
                        className="m-3 p-1 px-2 shadow-sm rounded-pill d-flex"
                        onClick={() => {
                          if (current > 0) {
                            const cTemp = parseInt(current) - 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          }
                        }}
                        disabled={current === 0}
                      >
                        <i className="material-icons">navigate_before</i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip {...props}>Bloque siguiente</Tooltip>}
                    >
                      <Button
                        variant="primary"
                        className="m-3 p-1 px-2 shadow-sm rounded-pill d-flex"
                        onClick={() => {
                          if (SiguienteB && current < SiguienteB) {
                            const cTemp = parseInt(current) + 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          } else if (current < actualBloque) {
                            const cTemp = parseInt(current) + 1;
                            setCurrent(cTemp);
                            dispatch(getBloque({}, bloques[cTemp].id));
                          }
                        }}
                        disabled={
                          SiguienteB === current ||
                          (actualBloque === current && SiguienteB === null) ||
                          SiguienteB === -1
                        }
                      >
                        <i className="material-icons">navigate_next</i>
                      </Button>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Col>
            </>
          )}
        </Container>
      </div>
      <Modal
        size="md"
        show={showModalView}
        onHide={() => {
          setShowModalView(false);
          // setFileName("Imagen, pdf, documento, etc.");
        }}
      >
        <Form onSubmit={onSubmitDocImg} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="font-weight-bold text-uppercase m-0">
                <i className="material-icons">file_upload</i>
                &nbsp;Subir archivo
              </h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!areasError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {areasError}
              </Alert>
            )}
            {!!carpetasError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {carpetasError}
              </Alert>
            )}
            {!!error && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {error}
              </Alert>
            )}
            {!!formErrors && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formErrors}
              </Alert>
            )}
            {!!subNivelesError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {subNivelesError}
              </Alert>
            )}
            <Form.Group as={Col} className="p-2 mb-3">
              <Form.File.Input
                className="p-2"
                name="documentos"
                label="Archivo a subir:"
                id="documentos"
                defaultValue={null}
                required
                disabled={
                  !(subNiveles && subNiveles.subNivelDescripcionList.length > 0)
                }
              />
              <Form.Control.Feedback type="invalid">
                <ul className="list-unstyled">
                  <li>**Es requerido un archivo de menor peso.</li>
                  <li>**Es requerido un archivo con formato pdf o imagen.</li>
                </ul>
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="px-2">
              <Form.Label className="ml-2">Descripción</Form.Label>
              <Form.Control
                as="select"
                name="documentDesc"
                className="rounded-pill"
                required
                placeholder="Descripción del documento"
                disabled={
                  !(subNiveles && subNiveles.subNivelDescripcionList.length > 0)
                }
              >
                <option value="" selected disabled>
                  Seleccione un descripción
                </option>
                {subNiveles &&
                  subNiveles.subNivelDescripcionList &&
                  subNiveles.subNivelDescripcionList.map((item, index) => (
                    <option key={index} value={item.descripcion}>
                      {item.descripcion}
                    </option>
                  ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="px-2">
              <Form.Label className="ml-2">Fecha de entrega</Form.Label>
              <Form.Control
                name="fechaDoc"
                className="rounded-pill"
                required
                type="date"
                placeholder="Descripción"
                disabled={
                  !(subNiveles && subNiveles.subNivelDescripcionList.length > 0)
                }
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            {editItem && editItem.archivo_gestor ? (
              <>
                <h6 className="text-muted ml-3">Archivo actual</h6>
                <ul className="list-unstyled">
                  <LinkDescargaGD
                    id={editItem.id}
                    filters={{
                      email: email,
                      id: editItem.archivo_gestor[0].id_documento,
                      llave: editItem.archivo_gestor[0].llave,
                    }}
                    origen={editItem.archivo_gestor[0].origen}
                    cType={editItem.archivo_gestor[0].contentTypeGD}
                  />
                </ul>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModalView(false)}
            >
              Cerrar
            </Button>
            <Button className="rounded-pill" variant="primary" type="submit">
              <p className="m-0">
                <i className="material-icons">file_upload</i>
                &nbsp;Subir
              </p>
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal
        size="lg"
        show={showModalCompañero}
        onHide={() => {
          setShowModalCompañero(false);
          // setFileName("Imagen, pdf, documento, etc.");
        }}
      >
        <Modal.Header className="bg-light text-dark" closeButton>
          <Modal.Title>
            <h4 className="d-flex flex-wrap justify-content-between align-items-center">
              <i className="material-icons mr-2">follow_the_signs</i>
              Responsable de la actividad
            </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col className="mx-auto p-3 mb-3" md="10">
            <Row>
              <Col className="mb-3 mt-3">
                <Col className="d-flex flex-wrap justify-content-center align-items-center">
                  <img
                    src={perfilImage}
                    className="image-employe-modal rounded"
                    alt="foto de perfil"
                  />
                </Col>
                <Col className="d-flex flex-wrap justify-content-center align-items-center">
                  <b>
                    {editItem &&
                    editItem.datos_compa_guia &&
                    editItem.datos_compa_guia.length > 0
                      ? editItem.datos_compa_guia[0].first_name
                      : "Compañero"}{" "}
                    {editItem &&
                    editItem.datos_compa_guia &&
                    editItem.datos_compa_guia.length > 0
                      ? editItem.datos_compa_guia[0].last_name
                      : "Guía"}
                  </b>
                </Col>
              </Col>
              <Col className="pt-5 pl-3">
                <p className="d-flex">
                  <i className="material-icons mr-2">email</i>
                  <b>
                    Email:{" "}
                    {editItem &&
                    editItem.datos_compa_guia &&
                    editItem.datos_compa_guia.length > 0
                      ? editItem.datos_compa_guia[0].email
                      : "empleado@farinter.hn"}
                  </b>
                </p>
              </Col>
            </Row>
            <Card.Text>
              Te hemos asignado a{" "}
              <b>
                {editItem &&
                editItem.datos_compa_guia &&
                editItem.datos_compa_guia.length > 0
                  ? editItem.datos_compa_guia[0].first_name
                  : "Compañero"}{" "}
                {editItem &&
                editItem.datos_compa_guia &&
                editItem.datos_compa_guia.length > 0
                  ? editItem.datos_compa_guia[0].last_name
                  : "Guía"}
              </b>{" "}
              para ser tu compañero(a) de apollo en esta etapa. Podras ver en tu
              calendario, actividades programada con ella como almuerzos y
              visitas.
            </Card.Text>
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Capacitacion;
